import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ICarbonIntensity } from 'src/domain/carbon-intensity/interface';
import { PriceType } from 'src/domain/price-response/interface';

const CALIFORNIA_COORDINATES: google.maps.LatLngLiteral = { lat: 36.7783, lng: -119.4179 };

interface SiteMapStore {
    mapLoaded: boolean;
    setMapLoaded: () => void;
    priceTypeValue: PriceType;
    setPriceTypeValue: (v: PriceType) => void;

    showLocalMwMap: boolean;
    setShowLocalMwMap: (v: boolean) => void;

    showCarbonIntensityMap: boolean;
    setShowCarbonIntensityMap: (v: boolean) => void;

    mapLocation: google.maps.LatLngLiteral;
    setMapLocation: (loc: google.maps.LatLngLiteral) => void;

    selectedLocationKey: string | null;
    setSelectedLocationKey: (key: string | null) => void;

    carbonIntensity: ICarbonIntensity[];
    setCarbonIntensity: (data: ICarbonIntensity[]) => void;

    isMarkersLoading: boolean;
    setMarkersLoading: (v: boolean) => void;
}

export const useSiteMapStore = create<SiteMapStore>()(
    persist(
        set => ({
            mapLoaded: false,
            setMapLoaded: () => set({ mapLoaded: true }),

            priceTypeValue: PriceType.REAL_TIME,
            setPriceTypeValue: v => set({ priceTypeValue: v }),

            showLocalMwMap: true,
            setShowLocalMwMap: v => set({ showLocalMwMap: v }),

            showCarbonIntensityMap: false,
            setShowCarbonIntensityMap: v => set({ showCarbonIntensityMap: v }),

            mapLocation: CALIFORNIA_COORDINATES,
            setMapLocation: loc => set({ mapLocation: { lat: loc.lat, lng: normalizeLongitude(loc.lng) } }),

            selectedLocationKey: null,
            setSelectedLocationKey: key => set({ selectedLocationKey: key }),

            carbonIntensity: [],
            setCarbonIntensity: data => set({ carbonIntensity: data }),

            isMarkersLoading: false,
            setMarkersLoading: v => set({ isMarkersLoading: v }),
        }),
        {
            name: 'drms.site-map',
            partialize: state => ({
                priceTypeValue: state.priceTypeValue,
                showLocalMwMap: state.showLocalMwMap,
                showCarbonIntensityMap: state.showCarbonIntensityMap,
            }),
        }
    )
);

function normalizeLongitude(longitude: number): number {
    let lng = longitude;
    while (Math.abs(lng) > 180) {
        lng = lng > 180 ? lng - 360 : lng + 360;
    }
    return lng;
}
